"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigationModule = _interopRequireDefault(require("./navigation.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _NavMenuContext = require("./NavMenuContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavContent = function NavContent(props) {
  var id = props.id,
      children = props.children,
      expanded = props.expanded;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      expandedMenuId = _useState2[0],
      setExpandedMenuId = _useState2[1];

  var handleMenuClick = function handleMenuClick(menuId) {
    setExpandedMenuId(function (prevMenuId) {
      return prevMenuId === menuId ? null : menuId;
    });
  };

  return _react.default.createElement(_NavMenuContext.NavMenuContext.Provider, {
    value: {
      expandedMenuId: expandedMenuId,
      handleMenuClick: handleMenuClick
    }
  }, _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_navigationModule.default["navbar-collapse"], _navigationModule.default["collapse"], expanded ? _navigationModule.default.in : "")
  }, children));
};

NavContent.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,
  children: _propTypes.default.any,

  /** Boolean indicating if the content is expanded  */
  expanded: _propTypes.default.bool
};
var _default = NavContent;
exports.default = _default;